import { useTranslation } from "react-i18next";
import { Button } from "barte-design-system";
import { PencilIcon } from "@phosphor-icons/react";

import { Skeleton } from "@shared/components";

import styles from "./pendency-header.module.css";

import type { PendencyHeaderProps } from "./pendency-header.type";

export const PendencyHeader = ({
  title,
  sellerName,
  count,
  isLoading,
  onClick,
}: PendencyHeaderProps) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className={styles.container}>
        <div className={styles["skeleton-info"]}>
          <Skeleton height="1.5rem" width="18rem" />
          <Skeleton height="1rem" width="14rem" />
        </div>
        <Skeleton height="2.5rem" width="9.5rem" />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <span className={styles.title}>
          {title || "-"}
        </span>

        <span className={styles.subtitle}>
          {t("payfac.pagePendenciesShowSeller")}:{" "}
          <span className={styles["seller-name"]}>{sellerName || "-"}</span>
        </span>
      </div>

      <Button onClick={onClick} variant="outline" size="sm" iconLeft={<PencilIcon />}>
        {t("payfac.pagePendenciesShowButtonResolve", { count })}
      </Button>
    </div>
  );
};
